var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-layout",
    [
      _c(
        "a-button",
        { attrs: { id: "scroll-to-bottom" }, on: { click: _vm.goToBottom } },
        [_c("a-icon", { attrs: { type: "arrow-down" } })],
        1
      ),
      _c(
        "div",
        {
          staticClass: "gx-custom-registration gx-main-content-wrapper",
          attrs: { id: "content" },
        },
        [
          _c("div", { staticClass: "gx-login-container" }, [
            _c(
              "div",
              { staticClass: "gx-login-content" },
              [
                _c("div", { staticClass: "login-brand gx-text-center" }, [
                  _c("img", {
                    staticStyle: { "max-height": "80px" },
                    attrs: {
                      alt: "SubsApp",
                      src: require("@/assets/regular-logo.png"),
                    },
                  }),
                ]),
                _c("div", { staticClass: "gx-login-header gx-text-center" }, [
                  _c("h1", { staticClass: "gx-login-title" }, [
                    _vm._v("Update Password"),
                  ]),
                ]),
                _vm.validationMsg && _vm.validationMsg.length
                  ? _c(
                      "div",
                      _vm._l(_vm.validationMsg, function (item, index) {
                        return _c("a-alert", {
                          key: index,
                          attrs: { type: "error", message: item, banner: "" },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _c(
                  "a-form",
                  {
                    staticClass: "gx-login-form gx-form-row0",
                    attrs: { form: _vm.form },
                  },
                  [
                    _c(
                      "a-form-item",
                      { staticClass: "gx-m-0", attrs: { label: "Password" } },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.fields.password,
                              expression: "fields.password",
                            },
                          ],
                          attrs: { placeholder: "Password", type: "password" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      { attrs: { label: "Confirm Password" } },
                      [
                        _c("a-input", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.fields.c_password,
                              expression: "fields.c_password",
                            },
                          ],
                          attrs: {
                            placeholder: "Confirm password",
                            type: "password",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      { staticClass: "gx-text-center" },
                      [
                        _c(
                          "a-button",
                          {
                            attrs: {
                              type: "primary",
                              block: "",
                              "html-type": "submit",
                              loading: _vm.loginLoading,
                            },
                            on: { click: _vm.handleForm },
                          },
                          [_vm._v("\n              Update\n            ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("div", { attrs: { id: "page-bottom" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }